module.exports = __webpack_public_path__ + "static/media/queue_4000x2000_4.090667cc.jpg";